import React from 'react';
import styles from './item.module.scss';



export function Item(props) {
  const { data } = props;

  return (
    <li className={styles['list-item']}>
      <span>{data.key}</span>
      <span>EGP {data.value}</span>
    </li>
  );
}

export default Item;
